export class ValidationError extends Error {}